import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import {
  FormBuilderEntityFieldModel,
  FormBuilderFieldTypes,
  GetFormBuilderByIdFieldDto,
  GetFormBuilderFieldsListDto,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { FormFieldsValidationsComponent } from '../../../base/form-fields-validations/form-fields-validations.component';

@Component({
  selector: 'app-fields',
  templateUrl: './fields.component.html',
  imports: [BaseFormModule, FormFieldsValidationsComponent],
})
export class FieldsComponent extends BaseFormPageComponent implements OnInit {
  //#region properties

  @Input() index: number;
  @Input() field: FormBuilderEntityFieldModel = {};
  @Input() formBuilderFieldsList: Array<any> = [];
  @Input() isFromModal: boolean = false;

  model: GetFormBuilderByIdFieldDto = {};
  selectListOptions: string[] = [];
  get formBuilderFieldTypes() {
    return FormBuilderFieldTypes;
  }

  @Output('fields') output_fields = new EventEmitter<any>();
  @Output('form') output_form = new EventEmitter<FormGroup>();
  @Output() orderChange = new EventEmitter<number>(); // Emit order change

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.fields = 'pages.formsManagement.form.fields.';
      this.detectChangeForm();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initModel();
  }

  initModel() {
    try {
      super.initModel();
      this.model = Object.assign({}, this.field);
      if (!this.model.validation) this.model.validation = {};
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      formBuilderFieldId: new FormControl('', Validators.required),
      isRequired: new FormControl(''),
      order: new FormControl(''),
      description: new FormControl(''),
    });
  }

  //#region emit
  onChangeFields(event: GetFormBuilderFieldsListDto) {
    this.model.formBuilderFieldId = event.id;
    this.model.formBuilderFieldTitle = event.title;
    this.model.fieldType = event.fieldType;
    this.selectListOptions = event.selectListOptions;
    this.model.selectListOptions = event.selectListOptions;
    this.emitModel();
  }

  emitModel() {
    this.output_fields.emit(this.model);
  }

  emitOrder() {
    this.orderChange.emit(this.model.order);
  }

  emitForm() {
    this.output_form.emit(this.form);
  }

  //#endregion

  detectChangeForm() {
    try {
      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((event) => {
          this.emitForm();
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }
}
